import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiGet, apiPost, apiDelete } from "@shared/queryHooks/api";

const getApiKey = async () => {
  return await apiGet({ path: "/api_keys" });
};

const createApiKey = async () => {
  return await apiPost({ path: "/api_keys", variables: {} });
};

const deleteApiKey = async () => {
  return await apiDelete({ path: "/api_keys", variables: {} });
};

/* Hooks
--===================================================-- */
export function useApiKey(): {
  status: any;
  data: any;
  error: any;
  isLoading: boolean;
} {
  return useQuery("apiKey", getApiKey, {
    refetchOnWindowFocus: false,
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useMutation(createApiKey, {
    onSuccess: (data) => {
      window.logger("%c[useCreateApiKey] onSuccess", "background-color: #10B981", {
        data,
        hasKey: "key" in data,
        keyValue: data?.key,
      });
      queryClient.invalidateQueries("apiKey");
    },
  });
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();
  return useMutation(deleteApiKey, {
    onSuccess: (data) => {
      window.logger("%c[useDeleteApiKey] onSuccess", "background-color: #EF4444", { data });
      queryClient.invalidateQueries("apiKey");
    },
  });
}
